import { render, staticRenderFns } from "./BookingCard.vue?vue&type=template&id=48e80b7b&scoped=true&"
import script from "./BookingCard.vue?vue&type=script&lang=ts&"
export * from "./BookingCard.vue?vue&type=script&lang=ts&"
import style0 from "./BookingCard.vue?vue&type=style&index=0&id=48e80b7b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e80b7b",
  null
  
)

export default component.exports